import { Directive } from '@angular/core';
import { AbstractControlDirective, NgControl } from '@angular/forms';
import { Observable } from 'rxjs';

@Directive({
    selector: '[luiFormFieldControl]',
    standalone: false
})
export abstract class FormFieldControlDirective<T> {
  value!: T | null;

  readonly stateChanges!: Observable<void>;

  readonly ngControl!: NgControl | AbstractControlDirective | null;
  readonly focused!: boolean;

  readonly empty!: boolean;

  readonly required!: boolean;

  readonly disabled!: boolean;

  readonly errorState!: boolean;
}
